import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  de: {
    translation: {
      'app.title': 'CV Optimizer',
      'app.description': 'Laden Sie Ihren CV hoch und erhalten Sie eine optimierte Version basierend auf der Stellenbeschreibung.',
      'upload.cv': 'CV hochladen',
      'upload.job': 'Stellenbeschreibung hochladen',
      'upload.job.description': 'Laden Sie eine Stellenbeschreibung hoch oder geben Sie sie manuell ein',
      'job.description': 'Stellenbeschreibung',
      'job.description.placeholder': 'Beschreiben Sie die Stelle, für die Sie sich bewerben...',
      'analyze': 'Analysieren',
      'download.original': 'Original CV herunterladen',
      'download.improved': 'Verbesserter CV herunterladen',
      'download.motivation': 'Motivationsschreiben herunterladen',
      'match.score': 'Übereinstimmung',
      'missing.skills': 'Fehlende Fähigkeiten',
      'improved.cv': 'Verbesserter CV',
      'motivation.letter': 'Motivationsschreiben',
      'loading': 'Lädt...',
      'error.upload': 'Fehler beim Hochladen',
      'error.analyze': 'Fehler bei der Analyse',
      'error.download': 'Fehler beim Herunterladen',
      'error.backend.api': 'Backend API URL nicht konfiguriert',
      'error.extract.cv': 'Fehler beim Extrahieren des CV-Texts',
      'error.extract.cv.unknown': 'Unbekannter Fehler beim Extrahieren des CV-Texts: ',
      'cv.original.text': 'Originaler CV Text',
      'cv.personal.info': 'Persönliche Angaben',
      'cv.tab.data': 'CV Daten',
      'cv.tab.start': 'Bewerbungen',
      'cv.tab.job.description': 'Stellenbeschreibung',
      'cv.tab.optimization': 'Optimierung',
      'cv.subtab.applications': 'Bewerbungen',
      'cv.subtab.job.description': 'Stellenbeschreibung',
      'cv.subtab.optimization': 'Optimierung',
      'button.next': 'Weiter',
      'button.back.to.applications': 'Zurück zu meinen Bewerbungen',
      'button.enter.job.description': 'Stellenbeschreibung erfassen',
             'cv.personal.fullname': 'Vollständiger Name',
       'cv.personal.company': 'Firma',
       'cv.personal.address': 'Adresse',
       'cv.personal.postal.code': 'Postleitzahl',
       'cv.personal.city': 'Ort',
       'cv.personal.phone': 'Telefonnummer',
      'cv.personal.email': 'E-Mail-Adresse',
      'cv.personal.birthyear': 'Jahrgang',
             'cv.personal.nationality': 'Nationalität',
       'cv.personal.nationality.select': 'Bitte wählen...',
       'cv.personal.nationality.swiss': 'Schweizer/in',
       'cv.personal.nationality.german': 'Deutsche/r',
       'cv.personal.nationality.austrian': 'Österreicher/in',
       'cv.personal.nationality.french': 'Franzose/in',
       'cv.personal.nationality.italian': 'Italiener/in',
       'cv.personal.nationality.spanish': 'Spanier/in',
       'cv.personal.nationality.british': 'Brite/in',
       'cv.personal.nationality.american': 'Amerikaner/in',
       'cv.personal.nationality.canadian': 'Kanadier/in',
       'cv.personal.nationality.australian': 'Australier/in',
       'cv.personal.nationality.japanese': 'Japaner/in',
       'cv.personal.nationality.chinese': 'Chinese/in',
       'cv.personal.nationality.indian': 'Inder/in',
       'cv.personal.nationality.brazilian': 'Brasilianer/in',
       'cv.personal.nationality.argentinian': 'Argentinier/in',
       'cv.personal.nationality.mexican': 'Mexikaner/in',
       'cv.personal.nationality.russian': 'Russe/Russin',
       'cv.personal.nationality.turkish': 'Türke/Türkin',
       'cv.personal.nationality.moroccan': 'Marokkaner/in',
       'cv.personal.nationality.egyptian': 'Ägypter/in',
       'cv.personal.nationality.south-african': 'Südafrikaner/in',
       'cv.personal.nationality.nigerian': 'Nigerianer/in',
       'cv.personal.nationality.kenyan': 'Keniaer/in',
       'cv.personal.nationality.other': 'Andere',
       'cv.personal.permit': 'Aufenthaltsbewilligung',
       'cv.personal.civilstatus': 'Zivilstand',
       'cv.personal.civilstatus.select': 'Bitte wählen...',
       'cv.personal.civilstatus.single': 'Ledig',
       'cv.personal.civilstatus.married': 'Verheiratet',
       'cv.personal.civilstatus.divorced': 'Geschieden',
       'cv.personal.civilstatus.widowed': 'Verwitwet',
       'cv.personal.civilstatus.registered-partnership': 'Eingetragene Partnerschaft',
       'cv.personal.profile.picture': 'Profilbild',
       'cv.personal.profile.upload': 'Bild hochladen',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Kurzprofil',
      'cv.work.experience': 'Berufserfahrung',
      'cv.education': 'Ausbildung',
      'cv.certificates': 'Weiterbildung / Zertifikate',
      'cv.languages': 'Sprachkenntnisse',
      'cv.languages.language': 'Sprache',
      'cv.languages.level': 'Niveau',
      'cv.it.skills': 'IT-Kenntnisse',
      'cv.it.skills.skill': 'Skill',
      'cv.it.skills.level': 'Niveau',
      'cv.additional.info': 'Weitere Angaben',
      'language.select': 'Sprache',
      'login.title': 'Anmelden',
      'login.email': 'E-Mail',
      'login.password': 'Passwort',
      'login.submit': 'Anmelden',
      'login.google': 'Mit Google anmelden',
      'login.tab.login': 'Anmelden',
      'login.tab.register': 'Registrieren',
      'login.password.confirm': 'Passwort bestätigen',
      'login.password.mismatch': 'Passwörter stimmen nicht überein',
      'login.password.too.short': 'Passwort muss mindestens 6 Zeichen lang sein',
      'login.password.requirements': 'Mindestens 6 Zeichen erforderlich',
      'login.password.strength': 'Passwort-Stärke',
      'login.password.min.length': 'Mindestens 6 Zeichen',
      'login.password.recommended': '8+ Zeichen (empfohlen)',
      'login.registering': 'Registrieren...',
      'login.logging.in': 'Anmelden...',
      'login.google.logging.in': 'Google Anmelden...',
      'login.register.button': 'Registrieren',
      'login.error.registration': 'Registrierung fehlgeschlagen',
      'login.error.login': 'Login fehlgeschlagen',
      'login.error.google': 'Google Login fehlgeschlagen',
      'login.verification.sent.title': 'Registrierung erfolgreich!',
      'login.verification.sent.message': 'Eine Verifizierungs-Email wurde an {email} gesendet. Bitte überprüfen Sie Ihr Postfach und klicken Sie auf den Bestätigungslink.',
      'login.verification.spam.warning': 'Wichtig: Prüfen Sie auch Ihren SPAM-ORDNER!',
      'login.verification.after.message': 'Nach der Verifizierung können Sie sich mit Ihren Zugangsdaten anmelden.',
      'login.verification.resend.button': 'Email erneut senden',
      'login.verification.resending': 'Sende...',
      'login.verification.resend.success': 'Verifizierungs-Email wurde erneut gesendet! Prüfen Sie auch Ihren Spam-Ordner.',
      'login.verification.resend.error': 'Fehler beim erneuten Senden der Email. Bitte überprüfen Sie Ihr Passwort.',
      'login.verification.password.prompt': 'Bitte geben Sie Ihr Passwort ein, um die Email erneut zu senden:',
      'login.verification.required': 'Bitte verifizieren Sie zuerst Ihre Email-Adresse. Prüfen Sie Ihr Postfach.',
      'login.forgot.password': 'Passwort vergessen?',
      'login.reset.title': 'Passwort zurücksetzen',
      'login.reset.info': 'Gib deine E‑Mail ein. Falls ein Konto existiert, senden wir dir Anweisungen zu.',
      'login.reset.sent': 'Wenn ein Konto existiert, haben wir dir eine E‑Mail gesendet.',
      'login.reset.submit': 'E‑Mail senden',
      'common.cancel': 'Abbrechen',
      'logout': 'Abmelden',
       'clear.all.data': 'Alle Daten löschen',
       'error.clear.data': 'Fehler beim Löschen der Daten: ',
       'Daten speichern': 'Daten speichern',
       'Keine Änderungen zum Speichern': 'Keine Änderungen zum Speichern',
       'ai.extraction.title': 'KI-gestützte Extraktion',
       'ai.extraction.description': 'Persönliche Daten werden automatisch mit KI extrahiert',
       'ai.extraction.fallback': 'KI-Extraktion fehlgeschlagen, verwende lokale Extraktion',
       'error.ai.extraction': 'Fehler bei der KI-Extraktion: ',
       'extraction.uploading': 'Datei wird hochgeladen...',
       'extraction.processing': 'CV wird verarbeitet...',
       'extraction.short.profile': 'Kurzprofil wird extrahiert...',
       'extraction.work.experience': 'Berufserfahrung wird extrahiert...',
       'extraction.education': 'Ausbildung wird extrahiert...',
       'extraction.certifications': 'Zertifikate werden extrahiert...',
              'extraction.personal.info': 'Persönliche Angaben werden extrahiert...',
       'extraction.fallback': 'Lokale Extraktion wird verwendet...',
       'extraction.complete': 'Extraktion abgeschlossen!',
       'cv.work.experience.add': 'Arbeitserfahrung hinzufügen',
      'cv.work.experience.period': 'Zeitraum',
      'cv.work.experience.company': 'Firma',
      'cv.work.experience.position': 'Position',
      'cv.education.add': 'Ausbildung hinzufügen',
      'cv.education.institution': 'Institution',
      'cv.education.degree': 'Abschluss',
      'cv.certification.add': 'Zertifizierung / Weiterbildung hinzufügen',
      'cv.certification.name': 'Name',
      'cv.certification.issuer': 'Aussteller',
      'cv.certification.date': 'Datum',
      'cv.certification.description': 'Beschreibung',
      'cv.certification.title': 'Zertifizierung / Weiterbildung',
      'cv.certification.extracted': 'Extrahierte Zertifizierungen',
      'button.cancel': 'Abbrechen',
      'button.add': 'Hinzufügen',
      'button.delete': 'Löschen',
      'label.start': 'Start',
      'label.end': 'Ende',
      "cv.education.title": "Ausbildung",
      "cv.education.startDate": "Startdatum",
      "cv.education.endDate": "Enddatum",
      'agb.title': 'Allgemeine Geschäftsbedingungen',
      'agb.welcome': 'Willkommen! Bitte lesen und akzeptieren Sie unsere Allgemeinen Geschäftsbedingungen, um die Anwendung nutzen zu können.',
      'agb.readInstructions': 'Bitte lesen Sie die AGBs sorgfältig durch:',
      'agb.link': 'AGBs öffnen (in neuem Tab)',
      'agb.confirmation': 'Ich habe die AGBs gelesen und akzeptiere sie.',
      'agb.confirmation.before': 'Ich habe die',
      'agb.confirmation.link': 'AGBs',
      'agb.confirmation.after': 'gelesen und akzeptiere sie.',
      'agb.notice': 'Hinweis: Sie müssen die AGBs akzeptieren, um die Anwendung nutzen zu können. Sie können sich jederzeit ausloggen.',
      'agb.logout': 'Ausloggen',
      'agb.accept': 'AGBs akzeptieren',
      'agb.accepting': 'Akzeptiere...',
      'agb.error.loading': 'Fehler beim Laden des AGB-Status',
      'agb.error.retry': 'Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
      'agb.error.reload': 'Seite neu laden',
      'cv.import.warning.title': 'Wichtiger Hinweis zur Datenqualität',
      'cv.import.warning.message': 'Bitte überprüfe die extrahierten Daten sorgfältig!',
      'cv.import.warning.description': 'Die KI-basierte Extraktion von CV-Daten erreicht keine 100%ige Genauigkeit. Es können Fehler bei der Erkennung von:',
      'cv.import.warning.item1': 'Namen, Adressen und Kontaktdaten',
      'cv.import.warning.item2': 'Berufserfahrungen und Zeiträumen',
      'cv.import.warning.item3': 'Ausbildungen und Zertifizierungen',
      'cv.import.warning.item4': 'Fähigkeiten und Kompetenzen',
      'cv.import.warning.footer': 'Bitte korrigiere alle erkannten Fehler, bevor du mit der Bewerbung fortfährst.',
      'cv.import.warning.button': 'Schliessen',
      'cv.import.warning.dontShowAgain': 'Diese Information nicht mehr zeigen.',
      'cv.template.warning.title': 'Wichtiger Hinweis zum optimierten CV',
      'cv.template.warning.message': 'Bitte lies den CV-Entwurf genau durch und passe ihn an!',
      'cv.template.warning.description': 'Die KI erstellt nur einen ersten Entwurf. Du musst den Feinschliff machen und folgende Bereiche überprüfen:',
      'cv.template.warning.item1': 'Rechtschreibung und Grammatik',
      'cv.template.warning.item2': 'Formatierung und Layout',
      'cv.template.warning.item3': 'Vollständigkeit der Informationen',
      'cv.template.warning.item4': 'Relevanz für die Stellenausschreibung',
      'cv.template.warning.footer': 'Nimm dir Zeit für eine sorgfältige Überarbeitung, bevor du den CV verwendest.',
      'cv.template.warning.button': 'Schliessen',
      'cv.template.warning.dontShowAgain': 'Diese Information nicht mehr zeigen.',
      'cv.motivation.warning.title': 'Wichtiger Hinweis zum Motivationsschreiben',
      'cv.motivation.warning.message': 'Bitte lies das Motivationsschreiben genau durch und passe es an!',
      'cv.motivation.warning.description': 'Die KI erstellt nur einen ersten Entwurf. Du musst den Feinschliff machen und folgende Bereiche überprüfen:',
      'cv.motivation.warning.item1': 'Rechtschreibung und Grammatik',
      'cv.motivation.warning.item2': 'Persönliche Ansprache und Ton',
      'cv.motivation.warning.item3': 'Relevanz für die Stellenausschreibung',
      'cv.motivation.warning.item4': 'Vollständigkeit der Argumente',
      'cv.motivation.warning.footer': 'Nimm dir Zeit für eine sorgfältige Überarbeitung, bevor du das Motivationsschreiben verwendest.',
      'cv.motivation.warning.button': 'Schliessen',
      'cv.motivation.warning.dontShowAgain': 'Diese Information nicht mehr zeigen.',
      'onboarding.title': 'Willkommen! Bitte vervollständige dein Profil',
      'onboarding.firstName': 'Vorname',
      'onboarding.lastName': 'Nachname',
      'onboarding.gender': 'Geschlecht',
      'onboarding.gender.male': 'Männlich',
      'onboarding.gender.female': 'Weiblich',
      'onboarding.gender.diverse': 'Divers',
      'onboarding.gender.unspecified': 'Keine Angabe',
      'onboarding.country': 'Land',
      'onboarding.country.ch': 'CH - Schweiz',
      'onboarding.country.de': 'DE - Deutschland',
      'onboarding.country.at': 'AT - Österreich',
      'onboarding.country.fr': 'FR - Frankreich',
      'onboarding.country.it': 'IT - Italien',
      'onboarding.save': 'Speichern',
      'onboarding.saving': 'Speichern...',
      'cv.image.upload.title.header': 'Header-Grafik auswählen',
      'cv.image.upload.title.column': 'Spalten-Grafik auswählen',
      'cv.image.upload.maxSize': 'Maximale Grafikgröße:',
      'cv.image.upload.maxSize.header': 'Header-Grafik: Maximal 794 Pixel (Breite) x 228 Pixel (Höhe)',
      'cv.image.upload.maxSize.column': 'Spalten-Grafik: Maximal 318 Pixel (Breite) x 1123 Pixel (Höhe)',
      'cv.image.upload.info': 'Bitte wählen Sie eine Grafik aus, die diese Abmessungen nicht überschreitet.',
      'cv.image.upload.alignment': 'Die Grafik wird links und oben ausgerichtet.',
      'cv.image.upload.select': 'Grafik auswählen',
      'cv.image.upload.error.tooLarge': 'Bild zu groß! Maximale Größe: {{maxWidth}}x{{maxHeight}} Pixel. Ihr Bild: {{width}}x{{height}} Pixel',
      'Passgenauigkeit akzeptieren': 'Passgenauigkeit akzeptieren',
      'CV-Vorschau öffnen': 'CV-Vorschau öffnen',
      'Erstellungsdatum': 'Erstellungsdatum',
    }
  },
  fr: {
    translation: {
      'app.title': 'Optimiseur de CV',
      'app.description': 'Téléchargez votre CV et obtenez une version optimisée basée sur la description du poste.',
      'upload.cv': 'Télécharger CV',
      'upload.job': 'Télécharger description de poste',
      'upload.job.description': 'Téléchargez une description de poste ou saisissez-la manuellement',
      'job.description': 'Description du poste',
      'job.description.placeholder': 'Décrivez le poste pour lequel vous postulez...',
      'analyze': 'Analyser',
      'download.original': 'Télécharger CV original',
      'download.improved': 'Télécharger CV amélioré',
      'download.motivation': 'Télécharger lettre de motivation',
      'match.score': 'Score de correspondance',
      'missing.skills': 'Compétences manquantes',
      'improved.cv': 'CV amélioré',
      'motivation.letter': 'Lettre de motivation',
      'loading': 'Chargement...',
      'error.upload': 'Erreur lors du téléchargement',
      'error.analyze': 'Erreur lors de l\'analyse',
      'error.download': 'Erreur lors du téléchargement',
      'error.backend.api': 'URL API backend non configurée',
      'error.extract.cv': 'Erreur lors de l\'extraction du texte du CV',
      'error.extract.cv.unknown': 'Erreur inconnue lors de l\'extraction du texte du CV: ',
      'cv.original.text': 'Texte CV original',
      'cv.personal.info': 'Informations personnelles',
      'cv.tab.data': 'Données CV',
      'cv.tab.start': 'Candidatures',
      'cv.tab.job.description': 'Description du poste',
      'cv.tab.optimization': 'Optimisation',
      'cv.subtab.applications': 'Candidatures',
      'cv.subtab.job.description': 'Description du poste',
      'cv.subtab.optimization': 'Optimisation',
      'button.next': 'Continuer',
      'button.back.to.applications': 'Retour à mes candidatures',
      'button.enter.job.description': 'Saisir la description du poste',
             'cv.personal.fullname': 'Nom complet',
       'cv.personal.company': 'Entreprise',
       'cv.personal.address': 'Adresse',
       'cv.personal.postal.code': 'Code postal',
       'cv.personal.city': 'Ville',
       'cv.personal.phone': 'Numéro de téléphone',
      'cv.personal.email': 'Adresse e-mail',
      'cv.personal.birthyear': 'Année de naissance',
             'cv.personal.nationality': 'Nationalité',
       'cv.personal.nationality.select': 'Veuillez sélectionner...',
       'cv.personal.nationality.swiss': 'Suisse',
       'cv.personal.nationality.german': 'Allemand(e)',
       'cv.personal.nationality.austrian': 'Autrichien(ne)',
       'cv.personal.nationality.french': 'Français(e)',
       'cv.personal.nationality.italian': 'Italien(ne)',
       'cv.personal.nationality.spanish': 'Espagnol(e)',
       'cv.personal.nationality.british': 'Britannique',
       'cv.personal.nationality.american': 'Américain(e)',
       'cv.personal.nationality.canadian': 'Canadien(ne)',
       'cv.personal.nationality.australian': 'Australien(ne)',
       'cv.personal.nationality.japanese': 'Japonais(e)',
       'cv.personal.nationality.chinese': 'Chinois(e)',
       'cv.personal.nationality.indian': 'Indien(ne)',
       'cv.personal.nationality.brazilian': 'Brésilien(ne)',
       'cv.personal.nationality.argentinian': 'Argentin(e)',
       'cv.personal.nationality.mexican': 'Mexicain(e)',
       'cv.personal.nationality.russian': 'Russe',
       'cv.personal.nationality.turkish': 'Turc(que)',
       'cv.personal.nationality.moroccan': 'Marocain(e)',
       'cv.personal.nationality.egyptian': 'Égyptien(ne)',
       'cv.personal.nationality.south-african': 'Sud-Africain(e)',
       'cv.personal.nationality.nigerian': 'Nigerian(e)',
       'cv.personal.nationality.kenyan': 'Kényan(e)',
       'cv.personal.nationality.other': 'Autre',
       'cv.personal.permit': 'Permis de séjour',
       'cv.personal.civilstatus': 'État civil',
       'cv.personal.civilstatus.select': 'Veuillez sélectionner...',
       'cv.personal.civilstatus.single': 'Célibataire',
       'cv.personal.civilstatus.married': 'Marié(e)',
       'cv.personal.civilstatus.divorced': 'Divorcé(e)',
       'cv.personal.civilstatus.widowed': 'Veuf/Veuve',
       'cv.personal.civilstatus.registered-partnership': 'Partenaire enregistré(e)',
       'cv.personal.profile.picture': 'Photo de profil',
       'cv.personal.profile.upload': 'Télécharger image',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Profil court',
      'cv.work.experience': 'Expérience professionnelle',
      'cv.education': 'Formation',
      'cv.certificates': 'Formation continue / Certificats',
      'cv.languages': 'Compétences linguistiques',
      'cv.languages.language': 'Langue',
      'cv.languages.level': 'Niveau',
      'cv.it.skills': 'Compétences informatiques',
      'cv.it.skills.skill': 'Compétence',
      'cv.it.skills.level': 'Niveau',
      'cv.additional.info': 'Informations supplémentaires',
      'language.select': 'Sélectionner la langue',
      'login.title': 'Se connecter',
      'login.email': 'E-mail',
      'login.password': 'Mot de passe',
      'login.submit': 'Se connecter',
      'login.google': 'Se connecter avec Google',
      'login.tab.login': 'Se connecter',
      'login.tab.register': 'S\'inscrire',
      'login.password.confirm': 'Confirmer le mot de passe',
      'login.password.mismatch': 'Les mots de passe ne correspondent pas',
      'login.password.too.short': 'Le mot de passe doit comporter au moins 6 caractères',
      'login.password.requirements': 'Au moins 6 caractères requis',
      'login.password.strength': 'Force du mot de passe',
      'login.password.min.length': 'Au moins 6 caractères',
      'login.password.recommended': '8+ caractères (recommandé)',
      'login.registering': 'Inscription...',
      'login.logging.in': 'Connexion...',
      'login.google.logging.in': 'Connexion Google...',
      'login.register.button': 'S\'inscrire',
      'login.error.registration': 'Échec de l\'inscription',
      'login.error.login': 'Échec de la connexion',
      'login.error.google': 'Échec de la connexion Google',
      'login.verification.sent.title': 'Inscription réussie!',
      'login.verification.sent.message': 'Un e-mail de vérification a été envoyé à {email}. Veuillez vérifier votre boîte de réception et cliquer sur le lien de confirmation.',
      'login.verification.spam.warning': 'Important: Vérifiez également votre dossier SPAM!',
      'login.verification.after.message': 'Après la vérification, vous pouvez vous connecter avec vos identifiants.',
      'login.verification.resend.button': 'Renvoyer l\'e-mail',
      'login.verification.resending': 'Envoi...',
      'login.verification.resend.success': 'L\'e-mail de vérification a été renvoyé! Vérifiez également votre dossier spam.',
      'login.verification.resend.error': 'Erreur lors du renvoi de l\'e-mail. Veuillez vérifier votre mot de passe.',
      'login.verification.password.prompt': 'Veuillez entrer votre mot de passe pour renvoyer l\'e-mail:',
      'login.verification.required': 'Veuillez d\'abord vérifier votre adresse e-mail. Vérifiez votre boîte de réception.',
      'login.forgot.password': 'Mot de passe oublié ?',
      'login.reset.title': 'Réinitialiser le mot de passe',
      'login.reset.info': 'Saisis ton e‑mail. Si un compte existe, nous t\'enverrons des instructions.',
      'login.reset.sent': 'Si un compte existe, nous t\'avons envoyé un e‑mail.',
      'login.reset.submit': 'Envoyer l\'e‑mail',
      'common.cancel': 'Annuler',
      'logout': 'Se déconnecter',
       'clear.all.data': 'Effacer toutes les données',
       'Daten speichern': 'Enregistrer les données',
       'Keine Änderungen zum Speichern': 'Aucune modification à enregistrer',
       'cv.work.experience.add': 'Ajouter expérience professionnelle',
       'cv.work.experience.period': 'Période',
       'cv.work.experience.company': 'Entreprise',
       'cv.work.experience.position': 'Poste',
       'cv.education.add': 'Ajouter formation',
       'cv.education.institution': 'Institution',
       'cv.education.degree': 'Diplôme',
       'cv.certification.add': 'Ajouter certification / formation continue',
       'cv.certification.name': 'Nom',
       'cv.certification.issuer': 'Émetteur',
       'cv.certification.date': 'Date',
       'cv.certification.description': 'Description',
       'cv.certification.title': 'Certification / Formation continue',
       'cv.certification.extracted': 'Certifications extraites',
       'button.cancel': 'Annuler',
       'button.add': 'Ajouter',
       'button.delete': 'Supprimer',
       'label.start': 'Début',
       'label.end': 'Fin',
       'extraction.uploading': 'Téléchargement du fichier...',
       'extraction.processing': 'Traitement du CV...',
       'extraction.short.profile': 'Extraction du profil court...',
       'extraction.work.experience': 'Extraction de l\'expérience professionnelle...',
       'extraction.education': 'Extraction de la formation...',
       'extraction.certifications': 'Extraction des certifications...',
       'extraction.personal.info': 'Extraction des données personnelles...',
       'extraction.fallback': 'Utilisation de l\'extraction locale...',
       'extraction.complete': 'Extraction terminée!',
       'error.clear.data': 'Errore durante la cancellazione dei dati: ',
       'ai.extraction.title': 'Estrazione assistita da IA',
       'ai.extraction.description': 'I dati personali vengono estratti automaticamente con l\'IA',
       "cv.education.title": "Formation",
       "cv.education.startDate": "Date de début",
       "cv.education.endDate": "Date de fin",
       'agb.title': 'Conditions générales',
       'agb.welcome': 'Bienvenue! Veuillez lire et accepter nos conditions générales pour utiliser l\'application.',
       'agb.readInstructions': 'Veuillez lire attentivement les CGU:',
       'agb.link': 'Ouvrir les CGU (nouvel onglet)',
       'agb.confirmation': 'J\'ai lu et j\'accepte les CGU.',
       'agb.confirmation.before': 'J\'ai lu les',
       'agb.confirmation.link': 'CGU',
       'agb.confirmation.after': 'et je les accepte.',
       'agb.notice': 'Remarque: Vous devez accepter les CGU pour utiliser l\'application. Vous pouvez vous déconnecter à tout moment.',
       'agb.logout': 'Se déconnecter',
       'agb.accept': 'Accepter les CGU',
      'agb.accepting': 'Acceptation...',
      'agb.error.loading': 'Erreur lors du chargement du statut CGU',
      'agb.error.retry': 'Veuillez réessayer ou contacter le support.',
      'agb.error.reload': 'Recharger la page',
      'cv.import.warning.title': 'Avis important sur la qualité des données',
      'cv.import.warning.message': 'Vérifie attentivement les données extraites !',
      'cv.import.warning.description': 'L\'extraction de données CV basée sur l\'IA n\'atteint pas une précision de 100%. Des erreurs peuvent survenir lors de la reconnaissance de :',
      'cv.import.warning.item1': 'Noms, adresses et données de contact',
      'cv.import.warning.item2': 'Expériences professionnelles et périodes',
      'cv.import.warning.item3': 'Formations et certifications',
      'cv.import.warning.item4': 'Compétences et capacités',
      'cv.import.warning.footer': 'Corrige toutes les erreurs détectées avant de continuer avec la candidature.',
      'cv.import.warning.button': 'Fermer',
      'cv.import.warning.dontShowAgain': 'Ne plus afficher cette information.',
      'cv.template.warning.title': 'Note importante sur le modèle CV',
      'cv.template.warning.message': 'Veuillez lire attentivement le projet de CV et l\'adapter !',
      'cv.template.warning.description': 'L\'IA ne crée qu\'un premier projet. Tu dois faire la finition et vérifier les domaines suivants :',
      'cv.template.warning.item1': 'Orthographe et grammaire',
      'cv.template.warning.item2': 'Formatage et mise en page',
      'cv.template.warning.item3': 'Exhaustivité des informations',
      'cv.template.warning.item4': 'Pertinence pour l\'offre d\'emploi',
      'cv.template.warning.footer': 'Prends le temps d\'une révision soigneuse avant d\'utiliser le CV.',
      'cv.template.warning.button': 'Fermer',
      'cv.template.warning.dontShowAgain': 'Ne plus afficher cette information.',
      'cv.motivation.warning.title': 'Note importante sur la lettre de motivation',
      'cv.motivation.warning.message': 'Veuillez lire attentivement la lettre de motivation et l\'adapter !',
      'cv.motivation.warning.description': 'L\'IA ne crée qu\'un premier projet. Tu dois faire la finition et vérifier les domaines suivants :',
      'cv.motivation.warning.item1': 'Orthographe et grammaire',
      'cv.motivation.warning.item2': 'Adresse personnelle et ton',
      'cv.motivation.warning.item3': 'Pertinence pour l\'offre d\'emploi',
      'cv.motivation.warning.item4': 'Exhaustivité des arguments',
      'cv.motivation.warning.footer': 'Prends le temps d\'une révision soigneuse avant d\'utiliser la lettre de motivation.',
      'cv.motivation.warning.button': 'Fermer',
      'cv.motivation.warning.dontShowAgain': 'Ne plus afficher cette information.',
      'onboarding.title': 'Bienvenue! Complète ton profil',
      'onboarding.firstName': 'Prénom',
      'onboarding.lastName': 'Nom',
      'onboarding.gender': 'Sexe',
      'onboarding.gender.male': 'Masculin',
      'onboarding.gender.female': 'Féminin',
      'onboarding.gender.diverse': 'Divers',
      'onboarding.gender.unspecified': 'Non spécifié',
      'onboarding.country': 'Pays',
      'onboarding.country.ch': 'CH - Suisse',
      'onboarding.country.de': 'DE - Allemagne',
      'onboarding.country.at': 'AT - Autriche',
      'onboarding.country.fr': 'FR - France',
      'onboarding.country.it': 'IT - Italie',
      'onboarding.save': 'Enregistrer',
      'onboarding.saving': 'Enregistrement...',
      'cv.image.upload.title.header': 'Sélectionner le graphique d\'en-tête',
      'cv.image.upload.title.column': 'Sélectionner le graphique de colonne',
      'cv.image.upload.maxSize': 'Taille maximale du graphique:',
      'cv.image.upload.maxSize.header': 'Graphique d\'en-tête: Maximum 794 pixels (largeur) x 228 pixels (hauteur)',
      'cv.image.upload.maxSize.column': 'Graphique de colonne: Maximum 318 pixels (largeur) x 1123 pixels (hauteur)',
      'cv.image.upload.info': 'Veuillez sélectionner un graphique qui ne dépasse pas ces dimensions.',
      'cv.image.upload.alignment': 'Le graphique sera aligné à gauche et en haut.',
      'cv.image.upload.select': 'Sélectionner le graphique',
      'cv.image.upload.error.tooLarge': 'Image trop grande! Taille maximale: {{maxWidth}}x{{maxHeight}} pixels. Votre image: {{width}}x{{height}} pixels',
      'Passgenauigkeit akzeptieren': 'Accepter le score de correspondance',
      'CV-Vorschau öffnen': 'Ouvrir l\'aperçu CV',
      'Erstellungsdatum': 'Date de création',
    }
  },
  it: {
    translation: {
      'app.title': 'Ottimizzatore CV',
      'app.description': 'Carica il tuo CV e ottieni una versione ottimizzata basata sulla descrizione del lavoro.',
      'upload.cv': 'Carica CV',
      'upload.job': 'Carica descrizione lavoro',
      'upload.job.description': 'Carica una descrizione del lavoro o inseriscila manualmente',
      'job.description': 'Descrizione del lavoro',
      'job.description.placeholder': 'Descrivi il lavoro per cui ti stai candidando...',
      'analyze': 'Analizza',
      'download.original': 'Scarica CV originale',
      'download.improved': 'Scarica CV migliorato',
      'download.motivation': 'Scarica lettera di motivazione',
      'match.score': 'Punteggio di corrispondenza',
      'missing.skills': 'Competenze mancanti',
      'improved.cv': 'CV migliorato',
      'motivation.letter': 'Lettera di motivazione',
      'loading': 'Caricamento...',
      'error.upload': 'Errore durante il caricamento',
      'error.analyze': 'Errore durante l\'analisi',
      'error.download': 'Errore durante il download',
      'error.backend.api': 'URL API backend non configurata',
      'error.extract.cv': 'Errore durante l\'estrazione del testo del CV',
      'error.extract.cv.unknown': 'Errore sconosciuto durante l\'estrazione del testo del CV: ',
      'cv.original.text': 'Testo CV originale',
      'cv.personal.info': 'Informazioni personali',
      'cv.tab.data': 'Dati CV',
      'cv.tab.start': 'Candidature',
      'cv.tab.job.description': 'Descrizione del lavoro',
      'cv.tab.optimization': 'Ottimizzazione',
      'cv.subtab.applications': 'Candidature',
      'cv.subtab.job.description': 'Descrizione del lavoro',
      'cv.subtab.optimization': 'Ottimizzazione',
      'button.next': 'Avanti',
      'button.back.to.applications': 'Torna alle mie candidature',
      'button.enter.job.description': 'Inserisci descrizione del lavoro',
             'cv.personal.fullname': 'Nome completo',
       'cv.personal.company': 'Azienda',
       'cv.personal.address': 'Indirizzo',
       'cv.personal.postal.code': 'Codice postale',
       'cv.personal.city': 'Città',
       'cv.personal.phone': 'Numero di telefono',
      'cv.personal.email': 'Indirizzo e-mail',
      'cv.personal.birthyear': 'Anno di nascita',
             'cv.personal.nationality': 'Nazionalità',
       'cv.personal.nationality.select': 'Seleziona...',
       'cv.personal.nationality.swiss': 'Svizzero/a',
       'cv.personal.nationality.german': 'Tedesco/a',
       'cv.personal.nationality.austrian': 'Austriaco/a',
       'cv.personal.nationality.french': 'Francese',
       'cv.personal.nationality.italian': 'Italiano/a',
       'cv.personal.nationality.spanish': 'Spagnolo/a',
       'cv.personal.nationality.british': 'Britannico/a',
       'cv.personal.nationality.american': 'Americano/a',
       'cv.personal.nationality.canadian': 'Canadese',
       'cv.personal.nationality.australian': 'Australiano/a',
       'cv.personal.nationality.japanese': 'Giapponese',
       'cv.personal.nationality.chinese': 'Cinese',
       'cv.personal.nationality.indian': 'Indiano/a',
       'cv.personal.nationality.brazilian': 'Brasiliano/a',
       'cv.personal.nationality.argentinian': 'Argentino/a',
       'cv.personal.nationality.mexican': 'Messicano/a',
       'cv.personal.nationality.russian': 'Russo/a',
       'cv.personal.nationality.turkish': 'Turco/a',
       'cv.personal.nationality.moroccan': 'Marocchino/a',
       'cv.personal.nationality.egyptian': 'Egiziano/a',
       'cv.personal.nationality.south-african': 'Sudafricano/a',
       'cv.personal.nationality.nigerian': 'Nigeriano/a',
       'cv.personal.nationality.kenyan': 'Kenyano/a',
       'cv.personal.nationality.other': 'Altro/a',
       'cv.personal.permit': 'Permesso di soggiorno',
       'cv.personal.civilstatus': 'Stato civile',
       'cv.personal.civilstatus.select': 'Seleziona...',
       'cv.personal.civilstatus.single': 'Celibe/Nubile',
       'cv.personal.civilstatus.married': 'Sposato/a',
       'cv.personal.civilstatus.divorced': 'Divorziato/a',
       'cv.personal.civilstatus.widowed': 'Vedovo/a',
       'cv.personal.civilstatus.registered-partnership': 'Unione civile',
       'cv.personal.profile.picture': 'Foto profilo',
       'cv.personal.profile.upload': 'Carica immagine',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Profilo breve',
      'cv.work.experience': 'Esperienza lavorativa',
      'cv.education': 'Formazione',
      'cv.certificates': 'Formazione continua / Certificati',
      'cv.languages': 'Competenze linguistiche',
      'cv.languages.language': 'Lingua',
      'cv.languages.level': 'Livello',
      'cv.it.skills': 'Competenze informatiche',
      'cv.it.skills.skill': 'Competenza',
      'cv.it.skills.level': 'Livello',
      'cv.additional.info': 'Informazioni aggiuntive',
      'language.select': 'Seleziona lingua',
      'login.title': 'Accedi',
      'login.email': 'E-mail',
      'login.password': 'Password',
      'login.submit': 'Accedi',
      'login.google': 'Accedi con Google',
      'login.tab.login': 'Accedi',
      'login.tab.register': 'Registrati',
      'login.password.confirm': 'Conferma password',
      'login.password.mismatch': 'Le password non corrispondono',
      'login.password.too.short': 'La password deve essere di almeno 6 caratteri',
      'login.password.requirements': 'Almeno 6 caratteri richiesti',
      'login.password.strength': 'Forza della password',
      'login.password.min.length': 'Almeno 6 caratteri',
      'login.password.recommended': '8+ caratteri (consigliato)',
      'login.registering': 'Registrazione...',
      'login.logging.in': 'Accesso...',
      'login.google.logging.in': 'Accesso Google...',
      'login.register.button': 'Registrati',
      'login.error.registration': 'Registrazione fallita',
      'login.error.login': 'Accesso fallito',
      'login.error.google': 'Accesso Google fallito',
      'login.verification.sent.title': 'Registrazione riuscita!',
      'login.verification.sent.message': 'Un\'e-mail di verifica è stata inviata a {email}. Controlla la tua casella di posta e clicca sul link di conferma.',
      'login.verification.spam.warning': 'Importante: Controlla anche la cartella SPAM!',
      'login.verification.after.message': 'Dopo la verifica, puoi accedere con le tue credenziali.',
      'login.verification.resend.button': 'Invia di nuovo l\'e-mail',
      'login.verification.resending': 'Invio...',
      'login.verification.resend.success': 'L\'e-mail di verifica è stata inviata di nuovo! Controlla anche la cartella spam.',
      'login.verification.resend.error': 'Errore durante l\'invio dell\'e-mail. Controlla la tua password.',
      'login.verification.password.prompt': 'Inserisci la tua password per inviare di nuovo l\'e-mail:',
      'login.verification.required': 'Verifica prima il tuo indirizzo e-mail. Controlla la tua casella di posta.',
      'login.forgot.password': 'Password dimenticata?',
      'login.reset.title': 'Reimposta password',
      'login.reset.info': 'Inserisci la tua e‑mail. Se esiste un account, ti invieremo le istruzioni.',
      'login.reset.sent': 'Se esiste un account, ti abbiamo inviato un\'e‑mail.',
      'login.reset.submit': 'Invia e‑mail',
      'common.cancel': 'Annulla',
      'logout': 'Disconnetti',
       'clear.all.data': 'Cancella tutti i dati',
       'Daten speichern': 'Salva dati',
       'Keine Änderungen zum Speichern': 'Nessuna modifica da salvare',
       'cv.work.experience.add': 'Aggiungi esperienza lavorativa',
       'cv.work.experience.period': 'Periodo',
       'cv.work.experience.company': 'Azienda',
       'cv.work.experience.position': 'Posizione',
       'cv.education.add': 'Aggiungi formazione',
       'cv.education.institution': 'Istituzione',
       'cv.education.degree': 'Laurea',
       'cv.certification.add': 'Aggiungi certificazione / formazione continua',
       'cv.certification.name': 'Nome',
       'cv.certification.issuer': 'Emittente',
       'cv.certification.date': 'Data',
       'cv.certification.description': 'Descrizione',
       'cv.certification.title': 'Certificazione / Formazione continua',
       'cv.certification.extracted': 'Certificazioni estratte',
       'button.cancel': 'Annulla',
       'button.add': 'Aggiungi',
       'button.delete': 'Elimina',
       'label.start': 'Inizio',
       'label.end': 'Fine',
       'extraction.uploading': 'Caricamento del file...',
       'extraction.processing': 'Elaborazione del CV...',
       'extraction.short.profile': 'Estrazione del profilo breve...',
       'extraction.work.experience': 'Estrazione dell\'esperienza lavorativa...',
       'extraction.education': 'Estrazione della formazione...',
       'extraction.certifications': 'Estrazione delle certificazioni...',
       'extraction.personal.info': 'Estrazione dei dati personali...',
       'extraction.fallback': 'Utilizzo dell\'estrazione locale...',
       'extraction.complete': 'Estrazione completata!',
       'error.clear.data': 'Errore durante la cancellazione dei dati: ',
       'ai.extraction.title': 'Estrazione assistita da IA',
       'ai.extraction.description': 'I dati personali vengono estratti automaticamente con l\'IA',
       "cv.education.title": "Formazione",
       "cv.education.startDate": "Data di inizio",
       "cv.education.endDate": "Data di fine",
       'agb.title': 'Termini e condizioni',
       'agb.welcome': 'Benvenuto! Si prega di leggere e accettare i nostri termini e condizioni per utilizzare l\'applicazione.',
       'agb.readInstructions': 'Si prega di leggere attentamente i termini e condizioni:',
       'agb.link': 'Aprire i termini e condizioni (nuova scheda)',
       'agb.confirmation': 'Ho letto e accetto i termini e condizioni.',
       'agb.confirmation.before': 'Ho letto i',
       'agb.confirmation.link': 'termini e condizioni',
       'agb.confirmation.after': 'e li accetto.',
       'agb.notice': 'Nota: È necessario accettare i termini e condizioni per utilizzare l\'applicazione. È possibile disconnettersi in qualsiasi momento.',
       'agb.logout': 'Disconnetti',
       'agb.accept': 'Accettare i termini e condizioni',
      'agb.accepting': 'Accettazione...',
      'agb.error.loading': 'Errore durante il caricamento dello stato dei termini e condizioni',
      'agb.error.retry': 'Si prega di riprovare o contattare il supporto.',
      'agb.error.reload': 'Ricaricare la pagina',
      'cv.import.warning.title': 'Avviso importante sulla qualità dei dati',
      'cv.import.warning.message': 'Verifica attentamente i dati estratti!',
      'cv.import.warning.description': 'L\'estrazione di dati CV basata su IA non raggiunge una precisione del 100%. Possono verificarsi errori nel riconoscimento di:',
      'cv.import.warning.item1': 'Nomi, indirizzi e dati di contatto',
      'cv.import.warning.item2': 'Esperienze lavorative e periodi',
      'cv.import.warning.item3': 'Formazioni e certificazioni',
      'cv.import.warning.item4': 'Competenze e abilità',
      'cv.import.warning.footer': 'Correggi tutti gli errori rilevati prima di procedere con la candidatura.',
      'cv.import.warning.button': 'Chiudi',
      'cv.import.warning.dontShowAgain': 'Non mostrare più questa informazione.',
      'cv.template.warning.title': 'Nota importante sul modello CV',
      'cv.template.warning.message': 'Leggi attentamente la bozza del CV e adattala!',
      'cv.template.warning.description': 'L\'IA crea solo una prima bozza. Devi fare la rifinitura e verificare le seguenti aree:',
      'cv.template.warning.item1': 'Ortografia e grammatica',
      'cv.template.warning.item2': 'Formattazione e layout',
      'cv.template.warning.item3': 'Completezza delle informazioni',
      'cv.template.warning.item4': 'Rilevanza per l\'annuncio di lavoro',
      'cv.template.warning.footer': 'Prenditi il tempo per una revisione accurata prima di utilizzare il CV.',
      'cv.template.warning.button': 'Chiudi',
      'cv.template.warning.dontShowAgain': 'Non mostrare più questa informazione.',
      'cv.motivation.warning.title': 'Nota importante sulla lettera di motivazione',
      'cv.motivation.warning.message': 'Per favore leggi attentamente la lettera di motivazione e adattala!',
      'cv.motivation.warning.description': 'L\'IA crea solo una prima bozza. Devi fare la rifinitura e controllare le seguenti aree:',
      'cv.motivation.warning.item1': 'Ortografia e grammatica',
      'cv.motivation.warning.item2': 'Indirizzo personale e tono',
      'cv.motivation.warning.item3': 'Rilevanza per l\'annuncio di lavoro',
      'cv.motivation.warning.item4': 'Completezza degli argomenti',
      'cv.motivation.warning.footer': 'Prenditi il tempo per una revisione accurata prima di utilizzare la lettera di motivazione.',
      'cv.motivation.warning.button': 'Chiudi',
      'cv.motivation.warning.dontShowAgain': 'Non mostrare più questa informazione.',
      'onboarding.title': 'Benvenuto! Completa il tuo profilo',
      'onboarding.firstName': 'Nome',
      'onboarding.lastName': 'Cognome',
      'onboarding.gender': 'Genere',
      'onboarding.gender.male': 'Maschile',
      'onboarding.gender.female': 'Femminile',
      'onboarding.gender.diverse': 'Diverso',
      'onboarding.gender.unspecified': 'Non specificato',
      'onboarding.country': 'Paese',
      'onboarding.country.ch': 'CH - Svizzera',
      'onboarding.country.de': 'DE - Germania',
      'onboarding.country.at': 'AT - Austria',
      'onboarding.country.fr': 'FR - Francia',
      'onboarding.country.it': 'IT - Italia',
      'onboarding.save': 'Salva',
      'onboarding.saving': 'Salvataggio...',
      'cv.image.upload.title.header': 'Seleziona grafica intestazione',
      'cv.image.upload.title.column': 'Seleziona grafica colonna',
      'cv.image.upload.maxSize': 'Dimensione massima grafica:',
      'cv.image.upload.maxSize.header': 'Grafica intestazione: Massimo 794 pixel (larghezza) x 228 pixel (altezza)',
      'cv.image.upload.maxSize.column': 'Grafica colonna: Massimo 318 pixel (larghezza) x 1123 pixel (altezza)',
      'cv.image.upload.info': 'Seleziona una grafica che non superi queste dimensioni.',
      'cv.image.upload.alignment': 'La grafica sarà allineata a sinistra e in alto.',
      'cv.image.upload.select': 'Seleziona grafica',
      'cv.image.upload.error.tooLarge': 'Immagine troppo grande! Dimensione massima: {{maxWidth}}x{{maxHeight}} pixel. La tua immagine: {{width}}x{{height}} pixel',
      'Passgenauigkeit akzeptieren': 'Accetta il punteggio di corrispondenza',
      'CV-Vorschau öffnen': 'Apri anteprima CV',
      'Erstellungsdatum': 'Data di creazione',
    }
  },
  en: {
    translation: {
      'app.title': 'CV Optimizer',
      'app.description': 'Upload your CV and get an optimized version based on the job description.',
      'upload.cv': 'Upload CV',
      'upload.job': 'Upload job description',
      'upload.job.description': 'Upload a job description or enter it manually',
      'job.description': 'Job description',
      'job.description.placeholder': 'Describe the job you are applying for...',
      'analyze': 'Analyze',
      'download.original': 'Download original CV',
      'download.improved': 'Download improved CV',
      'download.motivation': 'Download motivation letter',
      'match.score': 'Match score',
      'missing.skills': 'Missing skills',
      'improved.cv': 'Improved CV',
      'motivation.letter': 'Motivation letter',
      'loading': 'Loading...',
      'error.upload': 'Error uploading',
      'error.analyze': 'Error analyzing',
      'error.download': 'Error downloading',
      'error.backend.api': 'Backend API URL not configured',
      'error.extract.cv': 'Error extracting CV text',
      'error.extract.cv.unknown': 'Unknown error extracting CV text: ',
      'cv.original.text': 'Original CV text',
      'cv.personal.info': 'Personal information',
      'cv.tab.data': 'CV Data',
      'cv.tab.start': 'Applications',
      'cv.tab.job.description': 'Job Description',
      'cv.tab.optimization': 'Optimization',
      'cv.subtab.applications': 'Applications',
      'cv.subtab.job.description': 'Job Description',
      'cv.subtab.optimization': 'Optimization',
      'button.next': 'Next',
      'button.back.to.applications': 'Back to my applications',
      'button.enter.job.description': 'Enter Job Description',
             'cv.personal.fullname': 'Full name',
       'cv.personal.company': 'Company',
       'cv.personal.address': 'Address',
       'cv.personal.postal.code': 'Postal code',
       'cv.personal.city': 'City',
       'cv.personal.phone': 'Phone number',
      'cv.personal.email': 'Email address',
      'cv.personal.birthyear': 'Birth year',
             'cv.personal.nationality': 'Nationality',
       'cv.personal.nationality.select': 'Please select...',
       'cv.personal.nationality.swiss': 'Swiss',
       'cv.personal.nationality.german': 'German',
       'cv.personal.nationality.austrian': 'Austrian',
       'cv.personal.nationality.french': 'French',
       'cv.personal.nationality.italian': 'Italian',
       'cv.personal.nationality.spanish': 'Spanish',
       'cv.personal.nationality.british': 'British',
       'cv.personal.nationality.american': 'American',
       'cv.personal.nationality.canadian': 'Canadian',
       'cv.personal.nationality.australian': 'Australian',
       'cv.personal.nationality.japanese': 'Japanese',
       'cv.personal.nationality.chinese': 'Chinese',
       'cv.personal.nationality.indian': 'Indian',
       'cv.personal.nationality.brazilian': 'Brazilian',
       'cv.personal.nationality.argentinian': 'Argentinian',
       'cv.personal.nationality.mexican': 'Mexican',
       'cv.personal.nationality.russian': 'Russian',
       'cv.personal.nationality.turkish': 'Turkish',
       'cv.personal.nationality.moroccan': 'Moroccan',
       'cv.personal.nationality.egyptian': 'Egyptian',
       'cv.personal.nationality.south-african': 'South African',
       'cv.personal.nationality.nigerian': 'Nigerian',
       'cv.personal.nationality.kenyan': 'Kenyan',
       'cv.personal.nationality.other': 'Other',
       'cv.personal.permit': 'Residence permit',
       'cv.personal.civilstatus': 'Civil status',
       'cv.personal.civilstatus.select': 'Please select...',
       'cv.personal.civilstatus.single': 'Single',
       'cv.personal.civilstatus.married': 'Married',
       'cv.personal.civilstatus.divorced': 'Divorced',
       'cv.personal.civilstatus.widowed': 'Widowed',
       'cv.personal.civilstatus.registered-partnership': 'Registered partnership',
       'cv.personal.profile.picture': 'Profile picture',
       'cv.personal.profile.upload': 'Upload image',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Short profile',
      'cv.work.experience': 'Work experience',
      'cv.education': 'Education',
      'cv.certificates': 'Further education / Certificates',
      'cv.languages': 'Language skills',
      'cv.languages.language': 'Language',
      'cv.languages.level': 'Level',
      'cv.it.skills': 'IT skills',
      'cv.it.skills.skill': 'Skill',
      'cv.it.skills.level': 'Level',
      'cv.additional.info': 'Additional information',
      'language.select': 'Select language',
      'login.title': 'Login',
      'login.email': 'Email',
      'login.password': 'Password',
      'login.submit': 'Login',
      'login.google': 'Login with Google',
      'login.tab.login': 'Login',
      'login.tab.register': 'Register',
      'login.password.confirm': 'Confirm password',
      'login.password.mismatch': 'Passwords do not match',
      'login.password.too.short': 'Password must be at least 6 characters long',
      'login.password.requirements': 'At least 6 characters required',
      'login.password.strength': 'Password strength',
      'login.password.min.length': 'At least 6 characters',
      'login.password.recommended': '8+ characters (recommended)',
      'login.registering': 'Registering...',
      'login.logging.in': 'Logging in...',
      'login.google.logging.in': 'Google Login...',
      'login.register.button': 'Register',
      'login.error.registration': 'Registration failed',
      'login.error.login': 'Login failed',
      'login.error.google': 'Google login failed',
      'login.verification.sent.title': 'Registration successful!',
      'login.verification.sent.message': 'A verification email has been sent to {email}. Please check your inbox and click on the confirmation link.',
      'login.verification.spam.warning': 'Important: Also check your SPAM folder!',
      'login.verification.after.message': 'After verification, you can log in with your credentials.',
      'login.verification.resend.button': 'Resend email',
      'login.verification.resending': 'Sending...',
      'login.verification.resend.success': 'Verification email has been resent! Also check your spam folder.',
      'login.verification.resend.error': 'Error resending email. Please check your password.',
      'login.verification.password.prompt': 'Please enter your password to resend the email:',
      'login.verification.required': 'Please verify your email address first. Check your inbox.',
      'login.forgot.password': 'Forgot password?',
      'login.reset.title': 'Reset password',
      'login.reset.info': 'Enter your email. If an account exists, we\'ll send instructions.',
      'login.reset.sent': 'If an account exists, we\'ve sent you an email.',
      'login.reset.submit': 'Send email',
      'common.cancel': 'Cancel',
      'logout': 'Logout',
       'clear.all.data': 'Clear all data',
       'Daten speichern': 'Save data',
       'Keine Änderungen zum Speichern': 'No changes to save',
       'cv.work.experience.add': 'Add work experience',
       'cv.work.experience.period': 'Period',
       'cv.work.experience.company': 'Company',
       'cv.work.experience.position': 'Position',
       'cv.education.add': 'Add education',
       'cv.education.institution': 'Institution',
       'cv.education.degree': 'Degree',
       'cv.certification.add': 'Add certification / training',
       'cv.certification.name': 'Name',
       'cv.certification.issuer': 'Issuer',
       'cv.certification.date': 'Date',
       'cv.certification.description': 'Description',
       'cv.certification.title': 'Certification / Training',
       'cv.certification.extracted': 'Extracted certifications',
       'button.cancel': 'Cancel',
       'button.add': 'Add',
       'button.delete': 'Delete',
       'label.start': 'Start',
       'label.end': 'End',
       'extraction.uploading': 'Uploading file...',
       'extraction.processing': 'Processing CV...',
       'extraction.short.profile': 'Extracting short profile...',
       'extraction.work.experience': 'Extracting work experience...',
       'extraction.education': 'Extracting education...',
       'extraction.certifications': 'Extracting certifications...',
       'extraction.personal.info': 'Extracting personal information...',
       'extraction.fallback': 'Using local extraction...',
       'extraction.complete': 'Extraction complete!',
       'error.clear.data': 'Error clearing data: ',
       'ai.extraction.title': 'AI-assisted extraction',
       'ai.extraction.description': 'Personal data is automatically extracted with AI',
       "cv.education.title": "Education",
       "cv.education.startDate": "Start date",
       "cv.education.endDate": "End date",
       'agb.title': 'Terms and Conditions',
       'agb.welcome': 'Welcome! Please read and accept our Terms and Conditions to use the application.',
       'agb.readInstructions': 'Please read the Terms and Conditions carefully:',
       'agb.link': 'Open Terms and Conditions (new tab)',
       'agb.confirmation': 'I have read and accept the Terms and Conditions.',
       'agb.confirmation.before': 'I have read the',
       'agb.confirmation.link': 'Terms and Conditions',
       'agb.confirmation.after': 'and accept them.',
       'agb.notice': 'Note: You must accept the Terms and Conditions to use the application. You can log out at any time.',
       'agb.logout': 'Log out',
       'agb.accept': 'Accept Terms and Conditions',
      'agb.accepting': 'Accepting...',
      'agb.error.loading': 'Error loading Terms and Conditions status',
      'agb.error.retry': 'Please try again or contact support.',
      'agb.error.reload': 'Reload page',
      'cv.import.warning.title': 'Important Data Quality Notice',
      'cv.import.warning.message': 'Please carefully review the extracted data!',
      'cv.import.warning.description': 'AI-based CV data extraction does not achieve 100% accuracy. Errors may occur in the recognition of:',
      'cv.import.warning.item1': 'Names, addresses and contact data',
      'cv.import.warning.item2': 'Work experiences and time periods',
      'cv.import.warning.item3': 'Education and certifications',
      'cv.import.warning.item4': 'Skills and competencies',
      'cv.import.warning.footer': 'Please correct all detected errors before proceeding with the application.',
      'cv.import.warning.button': 'Close',
      'cv.import.warning.dontShowAgain': 'Don\'t show this information again.',
      'cv.template.warning.title': 'Important Note on CV Template',
      'cv.template.warning.message': 'Please read the CV draft carefully and adapt it!',
      'cv.template.warning.description': 'AI only creates a first draft. You need to do the fine-tuning and check the following areas:',
      'cv.template.warning.item1': 'Spelling and grammar',
      'cv.template.warning.item2': 'Formatting and layout',
      'cv.template.warning.item3': 'Completeness of information',
      'cv.template.warning.item4': 'Relevance for the job posting',
      'cv.template.warning.footer': 'Take time for a careful review before using the CV.',
      'cv.template.warning.button': 'Close',
      'cv.template.warning.dontShowAgain': 'Don\'t show this information again.',
      'cv.motivation.warning.title': 'Important note about the motivation letter',
      'cv.motivation.warning.message': 'Please read the motivation letter carefully and adapt it!',
      'cv.motivation.warning.description': 'The AI only creates a first draft. You need to do the finishing touches and check the following areas:',
      'cv.motivation.warning.item1': 'Spelling and grammar',
      'cv.motivation.warning.item2': 'Personal address and tone',
      'cv.motivation.warning.item3': 'Relevance to the job posting',
      'cv.motivation.warning.item4': 'Completeness of arguments',
      'cv.motivation.warning.footer': 'Take time for a careful revision before using the motivation letter.',
      'cv.motivation.warning.button': 'Close',
      'cv.motivation.warning.dontShowAgain': 'Don\'t show this information again.',
      'onboarding.title': 'Welcome! Please complete your profile',
      'onboarding.firstName': 'First name',
      'onboarding.lastName': 'Last name',
      'onboarding.gender': 'Gender',
      'onboarding.gender.male': 'Male',
      'onboarding.gender.female': 'Female',
      'onboarding.gender.diverse': 'Diverse',
      'onboarding.gender.unspecified': 'Not specified',
      'onboarding.country': 'Country',
      'onboarding.country.ch': 'CH - Switzerland',
      'onboarding.country.de': 'DE - Germany',
      'onboarding.country.at': 'AT - Austria',
      'onboarding.country.fr': 'FR - France',
      'onboarding.country.it': 'IT - Italy',
      'onboarding.save': 'Save',
      'onboarding.saving': 'Saving...',
      'cv.image.upload.title.header': 'Select Header Graphic',
      'cv.image.upload.title.column': 'Select Column Graphic',
      'cv.image.upload.maxSize': 'Maximum Graphic Size:',
      'cv.image.upload.maxSize.header': 'Header Graphic: Maximum 794 pixels (width) x 228 pixels (height)',
      'cv.image.upload.maxSize.column': 'Column Graphic: Maximum 318 pixels (width) x 1123 pixels (height)',
      'cv.image.upload.info': 'Please select a graphic that does not exceed these dimensions.',
      'cv.image.upload.alignment': 'The graphic will be aligned left and top.',
      'cv.image.upload.select': 'Select Graphic',
      'cv.image.upload.error.tooLarge': 'Image too large! Maximum size: {{maxWidth}}x{{maxHeight}} pixels. Your image: {{width}}x{{height}} pixels',
      'Passgenauigkeit akzeptieren': 'Accept match score',
      'CV-Vorschau öffnen': 'Open CV preview',
      'Erstellungsdatum': 'Creation date',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: [], // Kein Caching - Browser-Einstellungen haben immer Vorrang
    },
  });

// Funktion zum manuellen Sprachwechsel
export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language);
};

// Funktion zum Ersetzen von ß durch ss für Schweizer Texte
export const replaceEsszettForSwitzerland = (text: string, country: string | null): string => {
  if (country === 'CH') {
    return text.replace(/ß/g, 'ss');
  }
  return text;
};

// Erweiterte Übersetzungsfunktion mit CH-Unterstützung
// Diese Funktion wird aktuell nicht verwendet, da die Logik direkt in App.tsx implementiert ist
// Sie wird für zukünftige Verwendung bereitgehalten
export const tWithCountry = (key: string, country: string | null, options?: any): string => {
  // Hole die aktuelle Sprache aus i18n
  const currentLang = i18n.language || 'de';
  
  // Hole die Übersetzung direkt aus dem resources-Objekt
  const translation = (resources[currentLang as keyof typeof resources]?.translation as any)?.[key] || key;
  
  // Stelle sicher, dass translation ein String ist
  const translationString = typeof translation === 'string' ? translation : String(translation);
  return replaceEsszettForSwitzerland(translationString, country);
};

export default i18n; 